import React from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from './styles/theme';
import { SectionTitle } from './components';
import icoUser from '../../img/ico_User.png';

const MAX_DISPLAY_MESSAGES = 100;

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.lg,
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.md,
  },
  messageCount: {
    fontSize: 10,
    color: colors.text.muted,
    backgroundColor: colors.background.section,
    paddingVertical: 4,
    paddingHorizontal: spacing.sm,
    borderRadius: 2,
  },
  messagesContainer: {
    marginTop: spacing.sm,
  },
  message: {
    flexDirection: 'row',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
    borderLeftWidth: 3,
    borderLeftColor: colors.primary,
    borderLeftStyle: 'solid',
    marginBottom: spacing.sm,
  },
  messageAlt: {
    backgroundColor: colors.background.section,
    borderLeftColor: colors.primaryLight,
  },
  avatar: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: colors.background.table,
    marginRight: spacing.sm,
  },
  messageBody: {
    flex: 1,
    paddingRight: spacing.sm,
  },
  authorRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 2,
  },
  author: {
    fontSize: 9,
    fontWeight: 'bold',
    color: colors.text.primary,
    textTransform: 'capitalize',
  },
  timestamp: {
    fontSize: 8,
    color: colors.text.muted,
  },
  messageText: {
    fontSize: 10,
    color: colors.text.secondary,
    lineHeight: 1.4,
  },
  truncationNotice: {
    ...typography.caption,
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: colors.background.highlight,
  },
});

const Page6 = ({ chats = [] }) => {
  const displayChats = chats.slice(0, MAX_DISPLAY_MESSAGES);
  const isTruncated = chats.length > MAX_DISPLAY_MESSAGES;

  return (
    <View style={styles.container} break wrap>
      <View style={styles.headerRow}>
        <SectionTitle
          title="Registro de Conversaciones"
          subtitle="Mensajes del chat durante la transmisión"
          style={{ marginBottom: 0 }}
        />
        <Text style={styles.messageCount}>
          {chats.length} mensaje{chats.length !== 1 ? 's' : ''}
        </Text>
      </View>

      <View style={styles.messagesContainer} wrap>
        {displayChats.map((chat, index) => (
          <View
            key={chat.id || index}
            style={[styles.message, index % 2 === 1 && styles.messageAlt]}
            wrap={false}
          >
            <Image style={styles.avatar} src={icoUser} />
            <View style={styles.messageBody}>
              <View style={styles.authorRow}>
                <Text style={styles.author}>{chat.author?.name || 'Anónimo'}</Text>
                <Text style={styles.timestamp}>{chat.dateLabel}</Text>
              </View>
              <Text style={styles.messageText}>{chat.text}</Text>
            </View>
          </View>
        ))}
      </View>

      {isTruncated && (
        <Text style={styles.truncationNotice}>
          Se muestran los primeros {MAX_DISPLAY_MESSAGES} mensajes de un total de{' '}
          {chats.length}. El registro completo está disponible en la plataforma.
        </Text>
      )}
    </View>
  );
};

export default Page6;
